import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import LazyMap from "../../features/LazyMap";
import Logo from "../../assets/img/logo.png";

export default function Footer() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <footer>
      {pathname !== "/tourist-informations" && (
        <section className="map">
          <LazyMap />
        </section>
      )}
      <section className="w-full bg-[#1a1a1a] border-t border-white/10 py-6 px-6 text-xs text-gray-400">
        <div className="max-w-[88rem] mx-auto grid grid-cols-1 md:grid-cols-4 items-center gap-5 md:gap-10">

          {/* LEFT: Brand + legal links + copyright */}
          <div className="flex flex-col items-center text-center">
            <div className="flex items-center gap-2">
              <img src={Logo} alt="New Moon" className="w-7 h-7 object-contain" />
              <span className="text-lux-accent font-semibold text-base tracking-wide">New Moon</span>
            </div>
            <span className="text-gray-500 tracking-wide">{t("footer.tagline")}</span>

            <div className="mt-3 border-t border-gray-700 pt-3 w-full flex flex-col items-center gap-1">
              <div className="flex items-center gap-2">
                <Link to="/termini-e-condizioni" className="text-gray-300 hover:text-lux-accent transition-colors">
                  {t("footer.terms")}
                </Link>
                <span className="text-gray-600">·</span>
                <Link to="/privacy-policy" className="text-gray-300 hover:text-lux-accent transition-colors">
                  {t("footer.privacy")}
                </Link>
              </div>
              <div className="text-gray-500">
                &copy; {new Date().getFullYear()} New Moon. {t("footer.allRightsReserved")}
              </div>
            </div>
          </div>

          {/* CENTER: Locations */}
          <div className="flex flex-col items-center text-center">
            <h3 className="font-sans text-lux-accent text-xs uppercase tracking-widest font-semibold mb-2">
              {t("footer.findUsTitle")}
            </h3>
            <p className="text-sm text-gray-400">
              Corso Cavour 160, La Spezia
            </p>
            <p className="text-sm text-gray-400">
              Via del Prione 165, La Spezia
            </p>
          </div>

          {/* RIGHT: Legal info + contacts */}
          <div className="flex flex-col items-center text-center">
            <h3 className="font-sans text-lux-accent text-xs uppercase tracking-widest font-semibold mb-2">
              {t("footer.legalInfoTitle")}
            </h3>
            <p className="text-sm text-gray-400">
              Via Corso Cavour 160 - 19121 La Spezia (SP)
            </p>
            <p className="text-sm text-gray-400">
              {t("footer.vatLabel")} 01556750113
            </p>
            <div className="mt-3 border-t border-gray-700 pt-3 w-full flex flex-col items-center gap-1">
              <a
                href="https://wa.me/393348956214"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-lux-accent transition-colors"
              >
                +39 334 895 6214
              </a>
              <a
                href="mailto:info@newmoonrooms.it"
                className="text-gray-300 hover:text-lux-accent transition-colors"
              >
                info@newmoonrooms.it
              </a>
            </div>
          </div>

          {/* FAR RIGHT: CIN / CIR */}
          <div className="flex flex-col items-center text-center">
            <h3 className="font-sans text-lux-accent text-xs uppercase tracking-widest font-semibold mb-2">
              CIN · CIR
            </h3>
            <p className="text-sm text-gray-400">New Moon Cavour</p>
            <p className="text-xs text-gray-500">CIN: IT011015B49B55FBX4</p>
            <p className="text-xs text-gray-500">CIR/CITR: 011015-AFF-0387</p>
            <p className="text-sm text-gray-400 mt-2">New Moon Prione</p>
            <p className="text-xs text-gray-500">CIN: IT011015B4MJLIYDST</p>
            <p className="text-xs text-gray-500">CIR/CITR: 011015-AFF-0583</p>
          </div>

        </div>
      </section>
    </footer>
  );
}
